/** @format */

import React from "react";
import useUserRegisterHooks from "../../hooks/useUserRegisterHooks";
import { UserRegisterElement } from "../../components/ui_elements";
import { Container } from "../../components/layouts/Container";
import { ErrorHandler } from "../../api/ErrorHandler";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";

const UserRegister = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const {
    UserRegister,
    loginLinkUrl,
    normal,
    abnormal,
    setEmailHandler,
    setPasswordHandler,
    setConfirmPasswordHandler,
    errMsgs,
    passCheckState,
  } = useUserRegisterHooks(navigateByAgent);
  const { ErrorHandle } = ErrorHandler(navigateByAgent);

  // 登録実行イベント
  const UserRegisterHandler = async () => {
    const response = await UserRegister();
    //エラーハンドリング実行
    ErrorHandle(response, normal, abnormal, true);
  };

  return (
    <Container>
      <UserRegisterElement
        UserRegisterHandler={UserRegisterHandler}
        setEmailHandler={setEmailHandler}
        setPasswordHandler={setPasswordHandler}
        setConfirmPasswordHandler={setConfirmPasswordHandler}
        loginLinkUrl={loginLinkUrl}
        passCheckState={passCheckState}
        errMsgs={errMsgs}
      />
    </Container>
  );
};

export default UserRegister;
